export const saasProductShortands = ['pdl', 'payroll'];
